/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const colors = {
    transparent: 'transparent',
    current: 'currentColor',
    white: '#FFFFFF',

    null: 'transparent',

    black: {
        10: '#F5F5F5',
        20: '#E8E8E8',
        30: '#9F9F9F',
        40: '#A3A0A0',
        50: '#808080',
        60: '#636363',
        70: '#474747',
        80: '#2A2A2A',
        90: '#0E0E0E',
        100: '#000000',
    },

    'brand-primary': {
        60: '#F5ECEF',
        80: '#EA96B3',
        100: '#D11B59',
    },

    'brand-secondary': {
        60: '#94133F',
        80: '#94133F',
        100: '#730F31',
    },

    'brand-tertiary': {
        60: '#F2E9F3',
        80: '#C39BC6',
        100: '#7C2582',
    },

    danger: {
        60: '#FEF2F3',
        80: '#FFA2AB',
        100: '#DE1C2F',
    },

    success: {
        60: '#EAFEE7',
        80: '#6BF462',
        100: '#0F8A0F',
    },
    warning: {
        80: '#D6922D',
        100: '#C48527',
    },

    borderLight: '#D8D8D8',
    borderDark: '#000000',
    'border-inverse': '#FFFFFF',
    'brand-secondary-opacity': '#730F3199',
    imageBackground: 'transparent',
    overlayBackgroundModal: 'rgba(0, 0, 0, 0.75)',
    'accessibility-blue-light': '#15D6EA',
    'accessibility-blue-dark': '#1B96FF',
}

export default colors
